export const GOOGLE_DRIVE_CONNECTION_UNAVAILABLE_MESSAGE =
  "Google Drive connection is not yet available for all users.";

export const isGoogleDriveConnectionEnabled = () =>
  String(process.env.REACT_APP_ENABLE_GOOGLE_DRIVE || "").toLowerCase() ===
  "true";
